<div id="public" class="container">
  <div id="public-form-wrapper" fxLayout="column" fxLayoutAlign="start end" fxFlex="100">
    <div class="content-border" id="public-form">
      <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start start">
        <div fxLayout="column" fxFlex="100" fxAlign="center">
          <div id="public-content">
            <!-- Header -->
            <div class="navbar-default">

              <h2 style="margin-bottom: 0px !important;">
                <a style="color: #fff;" href="javascript:void(0)" [routerLink]="'/about'" [routerLinkActive]="['router-link-active']">About</a> |
                <a style="color: #fff;" href="javascript:void(0)" [routerLink]="'/timeline'" [routerLinkActive]="['router-link-active']">Timeline</a> <!--|-->
                <!--<a style="color: #fff;" href="javascript:void(0)" [routerLink]="'/privacy'" [routerLinkActive]="['router-link-active']">Privacy</a> |-->
                <!--<button mat-button [matMenuTriggerFor]="menu"><span style="color: #fff;">{{gamesNavButtonText}}</span></button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item [routerLink]="'/games/box-copter-hero'">Box Copter Hero</button>
    <button mat-menu-item [routerLink]="'/games/box-copter-hero-3d'">Box Copter Hero 3D</button>
    <button mat-menu-item [routerLink]="'/games/mad-scientist-and-monster'">Mad Scientist And Monster</button>
    <button mat-menu-item [routerLink]="'/games/metaltron'">MetalTron</button>
    <button mat-menu-item [routerLink]="'/games/r-down'">R Down</button>
    <button mat-menu-item [routerLink]="'/games/run-through-the-hills'">Run Through The Hills</button>
    <button mat-menu-item [routerLink]="'/games/swinging-in-caves'">Swingin' In Caves</button>
    <button mat-menu-item [routerLink]="'/games/symbol-match'">Symbol Match</button>
    <button mat-menu-item [routerLink]="'/games/the-star-maker'">The Star Maker</button>
  </mat-menu>
  <button mat-button [matMenuTriggerFor]="projectsMenu"><span style="color: #fff;">Projects</span></button>
  <mat-menu #projectsMenu="matMenu">
    <button mat-menu-item (click)="navigate('https://github.com/joemoceri/angularjs-chart-service')">angularjs-chart-service</button>
    <button mat-menu-item (click)="navigate('https://github.com/joemoceri/angularjs-datatables-service')">angularjs-datatables-service</button>
    <button mat-menu-item (click)="navigate('https://joemoceri.github.io/unity-effects-pack/')">Unity Effects Pack</button>
    <button mat-menu-item (click)="navigate('https://github.com/joemoceri/expression-evaluator-dotnet')">Expression Evaluator</button>
    <button mat-menu-item (click)="navigate('https://github.com/joemoceri/field-mapper')">Field Mapper</button>
    <button mat-menu-item (click)="navigate('https://github.com/joemoceri/google-analytics-service')">Google Analytics Service</button>
  </mat-menu>-->
                <a id="navigatorId" href="" target="_blank"></a>

                <span style="float: right;">
                  <button style="vertical-align: top;" mat-raised-button color="primary" (click)="navigate('/assets/joe-moceri-resume.pdf')">Resume</button>
                  <a style="padding: 6px; align-content: center;" href="https://www.linkedin.com/in/josephmoceri/" target="_blank"><img src="assets/images/icons/linkedin-icon.png" style="width: 32px; height: 32px;" /></a>
                  <a style="padding: 6px; align-content: center;" href="https://github.com/joemoceri" target="_blank"><img src="assets/images/icons/GitHub-Mark-32px.png" style="width: 32px; height: 32px;" /></a>
                </span>
              </h2>
            </div>
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
